import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useCallback, useEffect } from '@redneckz/uni-jsx/lib/hooks';
import { useEventListener } from '@redneckz/uni-jsx/lib/hooks/useEventListener';
import { style } from '../../utils/style.js';
import { useDialogManager } from './useDialogManager.js';
import { useDialogsList } from './useDialogsList.js';
export const DialogManager = JSX(() => {
    const handleCloseAll = useCallback((dialogs) => {
        for (const _ of dialogs) {
            _?.onClose && _.onClose();
        }
    }, []);
    const handleClose = useCallback((_) => {
        _?.onClose && _.onClose();
    }, []);
    const dialogs = useDialogsList({ onCloseAll: handleCloseAll, onClose: handleClose });
    const { close } = useDialogManager();
    const escapeHandler = useCallback(({ key }) => {
        if (key === 'Escape') {
            close();
        }
    }, []);
    useEventListener(globalThis.document, 'keydown', escapeHandler);
    useEffect(() => {
        if (dialogs.length) {
            globalThis.document?.body.classList.add('no-scrollbar');
            globalThis.document?.body.classList.add('overflow-hidden');
        }
        else {
            globalThis.document?.body.classList.remove('no-scrollbar');
            globalThis.document?.body.classList.remove('overflow-hidden');
        }
    }, [dialogs]);
    return dialogs.length ? (_jsx("div", { className: "fixed inset-0 z-50", role: "dialog", children: dialogs.map(({ dialog, id }, i) => (_jsx("div", { className: style('absolute inset-0 overflow-x-hidden overflow-y-scroll no-scrollbar bg-black/50', {
                hidden: i !== dialogs.length - 1,
            }), children: dialog }, String(id || i)))) })) : null;
});
//# sourceMappingURL=DialogManager.js.map